import "./App.css";

import { Routes, Route, Navigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";
import { useEffect, useState } from "react";

import Dashboard from "./pages/Dashboard";
import Deposit from "./pages/Deposit";
import BuyMachine from "./pages/BuyMachine";
import Refer from "./pages/Refer";
import Profile from "./pages/Profile";
import Withdraw from "./pages/Withdraw";
import AdminPanel from "./pages/AdminPanel";
import Support from "./pages/Support";
import Login from "./pages/Login";
import Signup from "./pages/Signup";

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(
      auth,
      (currentUser) => {
        setUser(currentUser);
        setLoading(false);
      }
    );

    return unsubscribe;
  }, []);

  if (loading) {
    return (
      <div
        style={{
          minHeight: "100vh",
          background: "#050505",
          color: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        Loading...
      </div>
    );
  }

  return (
    <Routes>
      <Route
        path="/"
        element={
          user ? (
            <Navigate to="/dashboard" replace />
          ) : (
            <Login />
          )
        }
      />

      <Route
        path="/login"
        element={
          user ? (
            <Navigate to="/dashboard" replace />
          ) : (
            <Login />
          )
        }
      />

      <Route
        path="/signup"
        element={
          user ? (
            <Navigate to="/dashboard" replace />
          ) : (
            <Signup />
          )
        }
      />

      <Route
        path="/dashboard"
        element={
          user ? <Dashboard /> : <Navigate to="/login" replace />
        }
      />

      <Route
        path="/deposit"
        element={
          user ? <Deposit /> : <Navigate to="/login" replace />
        }
      />

      <Route
        path="/machine"
        element={
          user ? <BuyMachine /> : <Navigate to="/login" replace />
        }
      />

      <Route
        path="/refer"
        element={
          user ? <Refer /> : <Navigate to="/login" replace />
        }
      />

      <Route
        path="/profile"
        element={
          user ? <Profile /> : <Navigate to="/login" replace />
        }
      />

      <Route
        path="/withdraw"
        element={
          user ? <Withdraw /> : <Navigate to="/login" replace />
        }
      />

      <Route
        path="/support"
        element={
          user ? <Support /> : <Navigate to="/login" replace />
        }
      />

      <Route
        path="/admin"
        element={
          user?.email?.toLowerCase() ===
          "paylink450@gmail.com" ? (
            <AdminPanel />
          ) : (
            <Navigate
              to={user ? "/dashboard" : "/login"}
              replace
            />
          )
        }
      />

      <Route
        path="*"
        element={
          <Navigate
            to={user ? "/dashboard" : "/login"}
            replace
          />
        }
      />
    </Routes>
  );
}

export default App;